module.exports = __webpack_public_path__ + "static/media/diag1v2.72244cf0.png";